import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil, faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import { Box, Link } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import usePublicationOption from '@hooks/usePublicationOption'

const confirmDelete = (deleteOption, deleteFn) => {
  const publicationOptionPayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Publication Option Deleted',
  }

  swal
    .fire({
      title: 'Delete Option?',
      text: 'Are you sure? This will delete the option and remove all it\'s values.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it.',
      confirmButtonColor: '#DD6B55',
    })
    .then(({ value }) => {
      if (value){
        deleteOption(publicationOptionPayload)
      }
    })
}

const OptionActions = (props) => {
  const { publicationOption } = props

  const {
    callbacks: {
      createOrEditPublicationOption,
      deletePublicationOption: deleteFn,
    },
  } = usePublicationOption(publicationOption)

  const {
    callbacks: { deleteOption },
  } = useContext(PageContext)

  return (
    <Box justifyContent="center">
      <Link greyLink onClick={() => createOrEditPublicationOption()} textProps={{ marginRight: 'medium' }}>
        <FontAwesomeIcon icon={faPencil} />
      </Link>

      <Link greyLink onClick={() => confirmDelete(deleteOption, deleteFn)}>
        <FontAwesomeIcon icon={faTrashAlt} />
      </Link>
    </Box>
  )
}

OptionActions.propTypes = {
  publicationOption: PropTypes.object.isRequired,
}

export default OptionActions
